import { Chip, Divider, Link } from "@mui/material";
import { Component } from "react";
import { ReactComponent as AddIcon } from "../resources/images/icons-add.svg";
import { ReactComponent as TickIcon } from "../resources/images/icons-check.svg";
import { ReactComponent as ChevronDownIcon } from "../resources/images/icons-chevron-down.svg";
import { ReactComponent as ChevronUpIcon } from "../resources/images/icons-chevron-up.svg";
import { Button } from "./Button";

export class ChipContainer extends Component<any, any> {
  static defaultProps = {
    limit: 5
  };

  constructor(props: any) {
    super(props);

    this.state = {
      showAll: props.showAll ? props.showAll : false,
      selectedItems: props.selectedItems ? props.selectedItems : []
    };
  }

  onShowMoreLess(e: any) {
    const { showAll } = this.state;

    this.setState({ showAll: !showAll });
  }

  onSelectAll(e: any) {
    e.preventDefault();

    const { items, onChange } = this.props;
    const { selectedItems } = this.state;

    this.setState({ selectedItems: this.isAllSelected() ? [] : items }, () => {
      if (onChange) onChange(e, this.state.selectedItems);
    });
  }

  isAllSelected() {
    const { items } = this.props;
    const { selectedItems } = this.state;
    return items.length === selectedItems.length;
  }

  onChipSelect(e: any, item: any) {
    const { onChange } = this.props;

    let { selectedItems } = this.state;
    if (selectedItems.includes(item)) selectedItems = selectedItems.filter((i: any) => i !== item);
    else selectedItems.push(item);

    this.setState({ selectedItems });

    if (onChange) onChange(e, selectedItems);
  }

  render() {
    const { items, limit, showDivider = true } = this.props;
    const { showAll, selectedItems } = this.state;

    return (
      <div className='klaro-chipcontainer'>
        {items.slice(0, showAll ? items.length : limit).map((i: any) => (
          <Chip<any>
            className={"klaro-chip" + (selectedItems.includes(i) ? " klaro-chip--selected" : "")}
            label={i.name}
            disableRipple={true}
            deleteIcon={selectedItems.includes(i) ? <TickIcon /> : <AddIcon />}
            onClick={(e: any) => this.onChipSelect(e, i)}
            onDelete={(e) => this.onChipSelect(e, i)}
            key={Math.random().toString(36).substring(7)}
            component='div'
          />
        ))}
        {showAll && (
          <Link className='klaro-chipcontainer_selectalllink' onClick={this.onSelectAll.bind(this)}>
            {this.isAllSelected() ? "Deselect all" : "Select all"}
          </Link>
        )}
        {items.length > limit ? (
          <div className='klaro-chipcontainer_showmore'>
            <Button
              autoFocus
              label={showAll ? "Show less" : "Show all"}
              variant='simple'
              size='sm'
              endIcon={showAll ? <ChevronUpIcon /> : <ChevronDownIcon />}
              onClick={this.onShowMoreLess.bind(this)}
            />
          </div>
        ) : showDivider ? (
          <Divider sx={{ marginTop: "20px" }} />
        ) : null}
      </div>
    );
  }
}
